import api from 'configs/api';
import { IRequestListResponse } from 'interfaces/RequestListResponse';
import { IRequestResponse } from 'interfaces/RequestResponse';
import {
  IStockPositionFilterOptions,
  IStockPositionFilterData,
  IExportGridData,
  IHistory,
  IWarehouse,
} from 'interfaces/StockPosition';

const endpointUrl = 'stock';

export const putGridStockPosition = async params => {
  const url = `${endpointUrl}`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};

export const postMaterialClassFilterOptions = async params => {
  const url = `${endpointUrl}/material-class/filter`;
  const { data } = await api.post<
    IRequestListResponse<IStockPositionFilterOptions>
  >(url, params);
  return data;
};

export const postGroupFilterOptions = async params => {
  const url = `${endpointUrl}/group/filter`;
  const { data } = await api.post<
    IRequestListResponse<IStockPositionFilterOptions>
  >(url, params);
  return data;
};

export const postDescriptionFilterOptions = async (qsparams, params) => {
  const url = `${endpointUrl}/description/filter?${qsparams}`;
  const { data } = await api.post<IRequestResponse<IStockPositionFilterData>>(
    url,
    params,
  );
  return data;
};

export const postAddStockOptions = async params => {
  const url = `${endpointUrl}/add`;
  const { data } = await api.post<
    IRequestListResponse<IStockPositionFilterOptions>
  >(url, params);
  return data;
};

export const getItemDescriptionOptions = async qsparams => {
  const url = `${endpointUrl}/description?${qsparams}`;
  const { data } = await api.get<IRequestResponse<IStockPositionFilterData>>(
    url,
  );
  return data;
};

export const getModelOptions = async qsparams => {
  const url = `${endpointUrl}/model?${qsparams}`;
  const { data } = await api.get<IRequestResponse<IStockPositionFilterData>>(
    url,
  );
  return data;
};

export const getSupplierOptions = async qsparams => {
  const url = `${endpointUrl}/supplier?${qsparams}`;
  const { data } = await api.get<IRequestResponse<IStockPositionFilterData>>(
    url,
  );
  return data;
};

export const getWareHouseOptions = async () => {
  const url = `${endpointUrl}/warehouse`;
  const { data } = await api.get<
    IRequestListResponse<IStockPositionFilterOptions>
  >(url);
  return data;
};

export const postExportStockGrid = async params => {
  const url = `${endpointUrl}/grid/excel`;
  const { data } = await api.post<IExportGridData>(url, params);
  return data;
};

export const postCancelActivity = async params => {
  const url = `${endpointUrl}/cancel`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const getMaterialClassOptions = async () => {
  const url = `${endpointUrl}/material-class`;
  const { data } = await api.get<
    IRequestListResponse<IStockPositionFilterOptions>
  >(url);
  return data;
};

export const getGroupOptions = async () => {
  const url = `${endpointUrl}/group`;
  const { data } = await api.get<
    IRequestListResponse<IStockPositionFilterOptions>
  >(url);
  return data;
};

export const getEntryHistory = async stockPositionId => {
  const url = `${endpointUrl}/history/entry/${stockPositionId}`;
  const { data } = await api.get<IRequestListResponse<IHistory>>(url);
  return data;
};

export const getRemovalHistory = async stockPositionId => {
  const url = `${endpointUrl}/history/exit/${stockPositionId}`;
  const { data } = await api.get<IRequestListResponse<IHistory>>(url);
  return data;
};

export const getWarehouseId = async installationId => {
  const url = `${endpointUrl}/warehouse/${installationId}`;
  const { data } = await api.get<IRequestListResponse<IWarehouse>>(url);
  return data;
};

export const postMoveItems = async params => {
  const url = `${endpointUrl}/move`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postExitSST = async params => {
  const url = `${endpointUrl}/exit-sst`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};
